import React from "react";
import ReactDOM from "react-dom";
import Modal from "react-responsive-modal";
import "./confirmDialog.css";

function ConfirmDialogView({
  open,
  title,
  message,
  confirmText,
  cancelText,
  danger,
  onConfirm,
  onCancel,
}) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      center
      closeOnEsc
      closeOnOverlayClick
      showCloseIcon={false}
      animationDuration={180}
      classNames={{ overlay: "zc-overlay", modal: "zc-modal" }}
    >
      <div className={`zc-card${danger ? " zc-card--danger" : ""}`}>
        <span className="zc-stamp">{danger ? "Confirm delete" : "Confirm required"}</span>
        <div className="zc-icon-chip" aria-hidden="true">
          {danger ? "!" : "?"}
        </div>
        {title && <h3 className="zc-title">{title}</h3>}
        <p className="zc-message">{message}</p>
        <div className="zc-actions">
          <button type="button" className="zc-btn zc-btn--ghost" onClick={onCancel} autoFocus>
            {cancelText || "Cancel"}
          </button>
          <button type="button" className="zc-btn zc-btn--primary" onClick={onConfirm}>
            {confirmText || (danger ? "Delete" : "Confirm")}
          </button>
        </div>
      </div>
    </Modal>
  );
}

let portalNode = null;
function getPortalNode() {
  if (!portalNode) {
    portalNode = document.createElement("div");
    portalNode.setAttribute("id", "zc-confirm-root");
    document.body.appendChild(portalNode);
  }
  return portalNode;
}

/**
 * Promise-based replacement for window.confirm(). Resolves true/false.
 * options: { title, confirmText, cancelText, danger = true }
 */
export function confirmDialog(message, options = {}) {
  const { title, confirmText, cancelText, danger = true } = options;
  const node = getPortalNode();

  return new Promise((resolve) => {
    const settle = (result) => {
      ReactDOM.render(
        <ConfirmDialogView
          open={false}
          title={title}
          message={message}
          confirmText={confirmText}
          cancelText={cancelText}
          danger={danger}
          onConfirm={() => {}}
          onCancel={() => {}}
        />,
        node,
      );
      resolve(result);
    };

    ReactDOM.render(
      <ConfirmDialogView
        open
        title={title}
        message={message}
        confirmText={confirmText}
        cancelText={cancelText}
        danger={danger}
        onConfirm={() => settle(true)}
        onCancel={() => settle(false)}
      />,
      node,
    );
  });
}
